import { useMemo } from 'react'
import Info from 'core/components/validatedForm/Info'
import ListTableField from 'core/components/validatedForm/ListTableField'
import ToggleSwitchField from 'core/components/validatedForm/ToggleSwitchField'
import Text from 'core/elements/Text'
import HintTooltip from 'core/elements/tooltip/HintTooltip'
import { filterAvailableCreateVmVolumes } from '../CreateVirtualMachineModal.helpers'
import useCreateVirtualMachineModalStyles from '../CreateVirtualMachineModal.styles'
import { volumeColumns } from '../helpers'

interface Props {
  availableVolumesRaw: any[]
  getParamsUpdater: any
  loadingAvailableVolumes: boolean
  params: any
  reloadAvailableVolumes: () => void
  updatingAvailableVolumes: boolean
}

export default function CreateVirtualMachineAttachVolumesStep({
  availableVolumesRaw,
  getParamsUpdater,
  loadingAvailableVolumes,
  params,
  reloadAvailableVolumes,
  updatingAvailableVolumes,
}: Props) {
  const classes = useCreateVirtualMachineModalStyles()

  const availableVolumes = useMemo(
    () =>
      filterAvailableCreateVmVolumes({
        availableVolumes: availableVolumesRaw,
        sourceType: params.sourceType,
        selectedBootVolumes: params.volume,
      }),
    [availableVolumesRaw, params.sourceType, params.volume],
  )

  return (
    <div className={classes.fields}>
      <Info className={classes.info}>
        <div className={classes.infoContent}>
          <Text variant="caption1">Attach Additional Volumes</Text>
          <Text variant="body2">
            Only volumes with <b>available</b> status may be selected below.
          </Text>
        </div>
      </Info>
      <Text variant="subtitle2">Volume</Text>
      <ListTableField
        id="volume"
        data={availableVolumes}
        onReload={reloadAvailableVolumes}
        loading={loadingAvailableVolumes || updatingAvailableVolumes}
        columns={volumeColumns}
        onChange={getParamsUpdater('attachVolumes')}
        value={params.attachVolumes}
        uniqueIdentifier="id"
        searchTargets={['name', 'status', 'volume_type', 'description']}
        emptyText="No available volumes found"
        multiSelection
      />
      {params.attachVolumes?.length > 0 && (
        <div>
          <ToggleSwitchField
            id="deleteOnTerminationAdditionalVolumes"
            value={params.deleteOnTerminationAdditionalVolumes}
            onChange={getParamsUpdater('deleteOnTerminationAdditionalVolumes')}
            customLabel={
              <div className={classes.toggleLabel}>
                <Text variant="caption1">Delete attached volumes on VM deletion</Text>
                <HintTooltip
                  message="If enabled, all attached volumes selected above will be deleted when the VM is deleted. If disabled, the volumes will remain after the VM is deleted."
                  align={{ vertical: 'bottom', horizontal: 'middle' }}
                />
              </div>
            }
          />
        </div>
      )}
    </div>
  )
}
